import { Icon, IconButton, HStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Text, Pressable } from 'native-base';
import React from 'react';

interface TableContentItemAddButtonProps {
  isSelected: boolean;
  isDisabled?: boolean;
  addCustomerToCart: () => void;
}

export const TableContentItemAddButton: React.FC<TableContentItemAddButtonProps> = ({
  isSelected,
  isDisabled,
  addCustomerToCart,
}) => {
  const isDesktop = useBreakpointValue({ base: false, lg: true });
  const baseColor = isDisabled ? 'neutral.lightest' : 'brand.tertiary.principal';

  const styleProps = {
    color: {
      desktop: isSelected ? 'feedback.error.default' : baseColor,
      mobile: isSelected ? 'feedback.error.lightest' : baseColor,
    },
    button: {
      text: isSelected ? 'REMOVER' : 'ADICIONAR',
    },
    icon: {
      name: isSelected ? 'Trash' : 'Addition',
      size: { desktop: 'xxxs', mobile: 'xxs' },
      color: {
        desktop: isSelected ? 'feedback.error.default' : baseColor,
        mobile: isSelected ? 'feedback.error.default' : 'neutral.white',
      },
    } as const,
  };

  if (isDesktop) {
    return (
      <Pressable
        testID="add-item-to-cart-icon-button"
        onPress={addCustomerToCart}
        isDisabled={isDisabled}>
        <HStack alignItems="center" space={Spacing['inline.nano']}>
          <Text
            color={styleProps.color.desktop}
            variant="semibold"
            fontSize={Typography['fontsize.md']}>
            {styleProps.button.text}
          </Text>
          <Icon
            name={styleProps.icon.name}
            size={styleProps.icon.size.desktop}
            color={Color[styleProps.icon.color.desktop]}
          />
        </HStack>
      </Pressable>
    );
  }

  return (
    <IconButton
      testId="add-item-to-cart-icon-button"
      onPress={addCustomerToCart}
      borderRadius={BoxRadius.sm}
      w="40px"
      h="40px"
      bgColor={styleProps.color.mobile}
      iconColor={Color[styleProps.icon.color.mobile]}
      icon={styleProps.icon.name}
      iconSize={styleProps.icon.size.mobile}
      isDisabled={isDisabled}
    />
  );
};
